import { Link, Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AllFilesDownloadProvider } from "../hooks/useAllFilesDownload";
import Header from "./Header";
import classNames from "classnames";
import { Container } from "reactstrap";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ProtectedLayout = () => {
  const { user, logout } = useAuth();
  const outlet = useOutlet();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <AllFilesDownloadProvider>
      <ToastContainer />
      <div className="App wrapper">
        <Container fluid>
          <Header />
          {outlet}
        </Container>
      </div>
    </AllFilesDownloadProvider>
  );
};
